import React, { useContext } from 'react';
import classes from './CloneCellTemplate.module.scss';
import { CellTemplateProps, PostingPlanCellDataType } from '../../../../models/calendar';
import { formatHour } from 'helpers/timeFormatter';
import { Timeslot } from '../Timeslot';
import classNames from 'classnames';
import { PostingPlanContext } from '../../../../providers/PostingPlanProvider';

export const CloneCellTemplateView = (props: CellTemplateProps<PostingPlanCellDataType>): JSX.Element => {
  const { row, position, timeFormat } = props;
  const [hour, day] = position;
  const notDroppable = row === undefined;
  const { timeslotToClone } = useContext(PostingPlanContext);

  const axisLabelClasses = classNames(classes.AxisLabel, classes.Clone);

  if (day === 0 && hour > 0 && notDroppable) {
    return (
      <td key={`${hour}-${day}-table-cell`} className={classes.AxisLabelCell}>
        <div className={classes.AxisLabelWrapper}>
          <div className={axisLabelClasses}>{formatHour(timeFormat, hour)}</div>
        </div>
      </td>
    );
  }

  const timeSlots = row?.map(timeslot => {
    const isToBeHighlighted = timeslotToClone?.category.id === timeslot.categoryId;

    return (
      <div key={timeslot.id} style={{ opacity: '0.5' }}>
        <Timeslot key={timeslot.id} {...timeslot} hovering={isToBeHighlighted} actions={undefined} isListView={false} />
      </div>
    );
  });

  return (
    <td key={`${hour}-${day}-table-cell`} className={classes.CalendarCellTemplate}>
      {timeSlots}
    </td>
  );
};
